export default {
  title: 'افزودنی',

  labels: {
    code: 'کد',
    name: 'نام',
    period: 'مدت زمان پلن',
    price: 'قیمت ماهیانه',
    salePrice: 'قیمت حراج',
    product: 'کالا',
    status: 'افزودنی فعال است',
    description: 'توضیحات',
    delete: 'حذف'
  },

  table: {
    header: {
      row: 'ردیف',
      code: 'کد',
      name: 'نام',
      period: 'دوره',
      price: 'قیمت ماهیانه',
      activeApps: 'اپلیکیشن های فعال',
      status: 'وضعیت',
      delete: 'حذف',
      restore: 'بازگردانی'
    }
  },

  notifications: {
    wrongInputValue: 'اطلاعات وارد شده صحیح نیست',
    requiredModulesNotSelected: 'ماژول+ های {modules} پیش نیاز این افزودنی هستند',
    insert: {
      success: 'افزودنی با موفقیت ایجاد شد',
      error: 'ایجاد افزودنی با خطا همراه شد'
    },
    edit: {
      success: 'افزودنی با موفقیت بروزرسانی شد',
      error: 'بروزرسانی افزودنی با خطا همراه شد'
    },
    delete: {
      success: 'افزودنی با موفقیت حذف شد',
      error: 'حذف افزودنی با خطا همراه شد'
    },
    restore: {
      success: 'افزودنی با موفقیت بازگردانی شد',
      error: 'بازگردانی افزودنی با خطا همراه شد'
    },
    editLimits: {
      success: 'محدودیت های افزودنی با موفقیت بروزرسانی شد',
      error: 'بروزرسانی محدودیت های افزودنی با خطا همراه شد'
    },
    parseError: {
      name: 'نام وارد شده معتبر نیست',
      code: 'کد وارد شده معتبر نیست یا قبلا استفاده شده است',
      price: 'قیمت وارد شده معتبر نیست'
    }
  },

  validators: {
    permissions: 'دسترسی برای افزودنی ست نشده است'
  },

  confirmations: {
    delete: {
      title: 'تاییدیه حذف افزودنی',
      body: 'آیا از حذف افزودنی مورد نظر اطمینان دارید؟'
    }
  },

  slugName: {
    users: 'اشخاص',
    products: 'کالا',
    advanced_products: 'کالای پیشرفته',
    services: 'خدمات',
    sales: 'فروش',
    purchases: 'خرید',
    treasury: 'خزانه داری',
    events: 'پیام ها',
    support_tickets: 'تیکت پشتیبانی',
    financial_years: 'سال مالی',
    settings: 'تنظیمات',
    point: 'امتیاز',
    max_debt: 'حداکثر اعتبار',
    users_group: 'گروه اشخاص',
    deficits: 'کسورات',
    conversions: 'تبدیلات',
    costs: 'هزینه ها',
    sale_suggest: 'پیشنهاد فروش',
    purchase_suggest: 'پیشنهاد خرید',
    reports: 'گزراشات',
    points: 'امتیازات',
    roles: 'دسترسی',
    warehouses: 'انبارداری',
    accountancy: 'حسابداری',
    organizational_tickets: 'تیکت سازمانی',
    woocommerce: 'ووکامرس',
    connector: 'ووکامرس',
    backups: 'پشتیبانی',
    company: 'شرکت',
    addons: {
      points: 'امتیاز',
      max_debt: 'حداکثر اعتبار',
      users_group: 'گروه اشخاص',
      deficits: 'کسورات',
      conversions: 'تبدیلات',
      costs: 'هزینه ها',
      cost: 'هزینه',
      tax: 'مالیات',
      opening_inventory: 'اول دوره',
      ai_suggest: 'پیشنهاد هوش مصنوعی',
      advanced_purchase: 'خرید پیشرفته',
      advanced_sale: 'فروش پیشرفته',
      woocommerce_connector: 'اتصالساز ووکامرس',
      cross_currency_pricing: 'قیمت گذاری مرجع',
      sale_report_by_attributes: 'گزارش فروش براساس ویژگی',
      sale_report_by_customer : 'گزارش فروش براساس مشتری',
    }
  },

  statusTypes: {
    active: 'فعال',
    disable: 'غیرفعال'
  },

  list: {
    title: 'افزودنی ها'
  },

  trash: {
    title: 'سطل زباله افزودنی ها'
  },

  insert: {
    title: 'افزودن افزودنی'
  },

  edit: {
    title: 'ویرایش افزودنی',
    dynamicTitle: 'ویرایش افزودنی {name}'
  },

  profile: {
    title: 'پروفایل افزودنی',
    dynamicTitle: 'پروفایل افزودنی {name}',

    importantData: {
      code: 'کد',
      price: 'قیمت',
      status: 'وضعیت'
    },

    actions: {
      apps: 'برنامه ها',
      limits: 'محدودیت ها',
      logs: 'لیست لاگ ها'
    }
  },

  apps: {
    title: 'لیست برنامه های افزودنی'
  },

  limits: {
    title: 'محدودیت های افزودنی',

    labels: {
      inMenu: 'منو'
    }
  },

  logs: {
    title: 'لاگ های افزودنی'
  }
}
